<template>
  <v-container :key="reloadKey">
    <HandleImportError
      :dialog="dialog"
      :errorMode="errorMode"
      :errors="errors"
      :showDependencyBtn="showDependencyBtn"
      @openCloseDialog="openCloseDialog"
      @getAdditionalImportedData="getAdditionalImportedData"
    />
    <v-row class="mt-0 pt-0">
      <v-col cols="6">
        <v-file-input :disabled="!pipeline"
        v-model="file"
        :accept="acceptedFormats"
        :label="'Import ' + acceptedFormats"
        show-size
        :rules="checkSize"
        clearable
        class="input-text-size" />
      </v-col>
      <v-col cols="6">
        <v-switch
          class="input-text-size"
          id="tmc-transform-import-isBackupNeeded"
          hide-details
          color="warning"
          v-model="isBackupNeeded"
          :label="isBackupNeeded ? 'Backup OFF' : 'Backup ON'" />
      </v-col>
    </v-row>
    <div class="d-flex align-center justify-space-around flex-row
        taxroll-table-wrapper-two">
      <v-btn class="input-text-size" text color="blue darken-1"
       @click="importFile" :disabled="disableButtons">
        {{ dynamicNameForImport }}
      </v-btn>
      <v-btn class="input-text-size" text color="blue darken-1" @click="viewFile">
        View File
      </v-btn>
    </div>
    <v-row v-if="importing">
      <v-col cols="2"></v-col>
      <v-col cols="8">
        <p class="input-text-size">{{statusText}}</p>
          <v-progress-linear
          color="deep-purple accent-4"
          :value="progress"
          rounded
          height="5"
          ></v-progress-linear>
      </v-col>
    </v-row>
    <v-row v-if="reload">
      <v-col cols="12">
        <v-btn class="input-text-size" rounded
          id="tmc-btn-import-state-reload-beta" @click="reloadMe">
          <v-icon class="mr-2">{{icons.mdiReload}}</v-icon> Load another
        </v-btn>
      </v-col>
      <v-col cols="12">
        <a v-if="hasReportTemplate"
          class="input-text-size"
          :href="dynamicReportUrl()"
          target="_blank">Open the report</a>
      </v-col>
      <v-col cols="12">
        <span class="input-text-size" v-if="showImportTimmings">Imported in: {{this.timing}}</span>
      </v-col>
    </v-row>
    <CRUDDialog ref="crudDialog" :baseCrudKey="baseCrudKey"
  dialogDynamicWidth="100vw"
  :canSave="false">
    <template v-slot:[`editedItem`]="{ }">
      <v-textarea id="edited-item-remarks"
          class="war-trans-item-remarks"
          rows="10"
          :value="dataFromImport"
          ></v-textarea>
    </template>
      </CRUDDialog>
  </v-container>
</template>

<script>
import {
  mdiReload,
} from '@mdi/js';
import {
  mapActions,
  mapMutations,
  mapState,
} from 'vuex';
import { clients } from '../../../util/clients';
import {
  dateDiffStr,
} from '../../../util/shared/tmc-global';
import {
  amountToNumber,
  sanitizeFilename,
} from '../../../util/shared/vue-global';
import {
  generateReportUrl,
  generateChunckID,
  getImportRedirectionUrl,
} from '../../config/TransformMapper.util';
import HandleImportError from '../../../views/bulk/HandleImportError.vue';
import { filePreValidate, importFileProgramMapperWithBackup } from '../../../views/bulk/import.utils';
// import { filePreValidate, importFileProgramMapperWithBackup } from './import.utils';
import CRUDDialog from '../base/crud-2.0/CRUDDialog.vue';
import '../../../assets/style.css';

const { backendRest } = clients.direct;

const initdata = () => ({
  form: new FormData(),
  dialog: false,
  errorMode: undefined,
  icons: {
    mdiReload,
  },
  file: undefined,
  importing: false,
  reload: false,
  reloadKey: 0,
  statusText: '',
  progress: 0,
  timing: undefined,
  errors: [],
  chunkID: '',
  additionalImportedData: {},
  programSelect: undefined,
  baseCrudKey: 'commonImportShowFile',
  dataFromImport: null,
  disableButtons: false,
  statusPolling: null,
  isBackupNeeded: false,
});

export default {
  name: 'CommonImportFiles',
  components: {
    HandleImportError,
    CRUDDialog,
  },
  data: () => initdata(),
  props: {
    acceptedFormats: {
      type: String,
      default: '.txt,.csv,.prn',
    },
    profileName: {
      type: String,
      default: '',
    },
    dynamicNameForImport: {
      type: String,
      default: 'Import',
    },
    dynamicUpdateInputs: {
      type: Object,
      default: () => {},
    },
    showImportTimmings: {
      type: Boolean,
      default: true,
    },
    makeBackupToTrue: {
      type: Boolean,
      default: false,
    },
    // Optional async source for the file, used when nothing has been picked with
    // the file input. Bill Requests supplies one that pulls the chosen file off the
    // FTP server. Called at Import time only, and the File it returns goes through
    // exactly the same pre-validate / backup / upload path as a local pick, so
    // there is no second import route to keep in step with this one.
    // Returning null means "nothing to import" and Import quietly does nothing.
    fileResolver: {
      type: Function,
      default: null,
    },
  },
  computed: {
    ...mapState({
      warSettingItem: (state) => state.SystemConfig.warSettingItem,
      pipeline: (state) => state.tax.MortgageCoProcessing.pipeline,
    }),
    showDependencyBtn() {
      return (this.pipeline || {}).createDependency || false;
    },
    checkSize() {
      return [
        (value) => {
          if (value && value.size > 30000000) {
            this.disableButtons = true;
            return 'File size should be less than 30 MB';
          }
          this.disableButtons = false;
          return true;
        },
      ];
    },
  },
  created() {
    this.loadConfig({ requiredScope: 'warconfig' });
    this.loadConfig({ requiredScope: 'global' });
  },
  mounted() {
    this.isBackupNeeded = this.makeBackupToTrue;
  },
  methods: {
    ...mapActions('SystemConfig', ['loadConfig']),
    ...mapActions('jobs', [
      'backup',
    ]),
    ...mapMutations('jobs', [
      'setPrefix',
      'setGroup',
      'setCollection',
    ]),
    ...mapActions([
      'flashError',
      'flashInfo',
      'flashSuccess',
    ]),
    ...mapMutations('base/crud', [
      'setIsVisible',
    ]),
    handleDialog() {
      this.setIsVisible([this.baseCrudKey, true]);
    },
    getAdditionalImportedData(val) {
      this.additionalImportedData = { ...val };
    },
    openCloseDialog(value) {
      this.dialog = value;
    },
    // async onFileSelected(file) {
    //   console.info(file);
    //   if (file) {
    //     await this.importFile(file);
    //   }
    // },
    async insertUploadedFile(form) {
      this.importing = true;
      try {
        form.append('preValidate', false);
        const formHeaders = {
          'Content-Type': 'multipart/form-data',
        };
        const results = await backendRest.post('/transmap/import', form, {
          headers: formHeaders,
          onUploadProgress: (progEvt) => {
            console.info('upload');
            try {
              const percentComplete = (progEvt.loaded / progEvt.total) * 100;
              this.statusText = `${percentComplete}% of file uploaded...`;
              this.progress = percentComplete;
            } catch {
              // do nothing
            }
          },
          onDownloadProgress: (progEvt) => {
            console.info('download');
            try {
              const kbRecvd = progEvt.loaded / 1024;
              this.statusText = `Getting import progress (${amountToNumber(kbRecvd)} kb)...`;
              this.progress = kbRecvd;
            } catch {
              // do nothing
            }
          },
        });
        this.importing = false;
        this.statusText = '';
        this.file = undefined;

        const startDt = this.timing;
        const endDt = new Date();
        this.timing = dateDiffStr(startDt, endDt);

        this.reload = true;
        if (!results || !results.data || results.data.ok !== 1) {
          this.flashError('Unable to upload file.');
          return false;
        }
        this.$emit('loadCRUDList');
        this.flashSuccess('Imported!');

        this.form = new FormData();
        if (!(this.errors == null) && this.errors.length > 0) {
          this.$router.push({
            name: 'Auto Created Dependencies',
            params: {
              args: this.errors,
              redirectToPage: {
                url: this.dynamicReportUrl(),
                params: this.chunkID,
              },
            },
          });
        }
        // else {
        //   this.openIfReportTemplate();
        // }
        return true;
      } catch (err) {
        console.error('Error while upserting imported file', err);
      }
      return true;
    },
    viewFile() {
      const { file } = this;
      if (file) {
        const bytesVal = 1000000; // its equal to 1mb
        const chunkSize = 2000;
        const fileSize = (file.size > bytesVal) ? bytesVal : file.size;
        const dataVal = [];
        for (let i = 0; i < fileSize; i += chunkSize) {
          // eslint-disable-next-line func-names
          (function (fil, start) {
            const reader = new FileReader();
            const blob = fil.slice(start, chunkSize + start);
            reader.readAsText(blob);
            reader.addEventListener(
              'load',
              () => {
                dataVal.push(reader.result);
              },
              false,
            );
          }(file, i));
        }
        this.dataFromImport = dataVal;
        this.handleDialog();
      }
    },
    async takeDbBackup() {
      this.importing = true;
      this.statusText = 'Loading file...';
      let successfulBackup = false;
      if (window.confirm('Would you like to take a backup before bulk changes?')) {
        this.setGroup('tmc-local-backend');
        this.setPrefix(`importfilesprebackup_${this.pipeline.program}`);
        const collection = importFileProgramMapperWithBackup[this.pipeline.program];
        // if mapper will not match with any program, it will get 'undefined'
        this.setCollection(collection);
        successfulBackup = await this.backup();
      }
      if (!successfulBackup) {
        this.importing = false;
        this.statusText = '';
        this.file = null;
      }
      return successfulBackup;
    },
    async importFile() {
      // A locally picked file wins; otherwise ask the parent for one (Bill Requests
      // fetches the selected FTP file here rather than on selection). Deliberately
      // before the backup prompt, so a failed fetch cannot trigger a pointless backup.
      let { file } = this;
      let fromResolver = false;
      if (!file && this.fileResolver) {
        this.disableButtons = true;
        try {
          file = await this.fileResolver();
        } finally {
          this.disableButtons = false;
        }
        fromResolver = true;
      }

      // Nothing picked locally and nothing the resolver could supply. Said out loud
      // rather than returning quietly: an Import that does nothing at all reads as a
      // dead button, with no way to tell it apart from a failed request.
      if (!file) {
        this.flashInfo('Please choose a file to import, or select one from the file list.');
        return false;
      }

      if (file) {
        try {
          this.timing = new Date();

          // backup the db
          // A file that came from the resolver (i.e. pulled off FTP) skips the backup
          // outright - no prompt, no dump. Scoped to that path rather than to the whole
          // screen, so a file chosen with the file input keeps the safety net it has today.
          if (!this.isBackupNeeded && !fromResolver) {
            const successfulBackup = await this.takeDbBackup();
            // if backup failed, return
            if (!successfulBackup) return false;
          } // if backup is not needed, continue

          this.disableButtons = true;
          let objCheckDataExits = {};
          if (this.dynamicUpdateInputs && Object.keys(this.dynamicUpdateInputs).length) {
            objCheckDataExits = this.dynamicUpdateInputs;
          }
          let inputsStr = this.pipeline.inputs;
          let profileNameNotExits = {};
          if (this.profileName !== '') profileNameNotExits = { type: 'constant', prop: 'profileName', value: this.profileName };
          const clubbedObj = { ...profileNameNotExits, ...objCheckDataExits };
          // if dynamic update inputs is not empty, then add the clubbedObj to the inputs
          if (this.dynamicUpdateInputs && Object.keys(this.dynamicUpdateInputs).length) {
            inputsStr = JSON.stringify([clubbedObj]);
          } else {
            inputsStr = JSON.stringify([]);
          }

          // import the file
          const form = new FormData();
          form.append('fileName', sanitizeFilename(file.name));
          form.append('transMapName', this.pipeline.name);
          form.append('inputs', inputsStr);
          form.append('data', file);
          form.append('preValidate', true);
          this.chunkID = generateChunckID({ profileName: this.pipeline.name });
          form.append('chunkID', this.chunkID);
          form.append('profileID', this.pipeline._id);
          form.append('batchSize', this.pipeline.batchSize);

          const formHeaders = {
            'Content-Type': 'multipart/form-data',
          };
          [this.dialog, this.errors, this.errorMode] = await filePreValidate({ form, formHeaders });
          if (this.dialog) {
            this.form = form;
            return false;
          }

          this.insertUploadedFile(form);
          this.disableButtons = false;
          return true;
        } catch (err) {
          this.disableButtons = false;
          console.error(err);
          this.flashError('There was a problem while importing your file.');
          return false;
        }
      }
      return false;
    },
    dynamicReportUrl() {
      const programWiseSettings = {
        warSettings: this.warSettingItem,
      };
      const redirectionUrl = getImportRedirectionUrl(this.pipeline,
        this.programSelect, programWiseSettings);
      const parsedInputs = JSON.parse(this.pipeline.inputs || '[]');
      const route = generateReportUrl(
        redirectionUrl,
        parsedInputs,
        {
          chunkID: this.chunkID,
          program: this.pipeline.program,
        },
      );
      return route;
    },
    hasReportTemplate() {
      return (this.pipeline.reportTemplate || '').length > 0;
    },
    // openIfReportTemplate() {
    // if (this.hasReportTemplate()) {
    //   const toUrl = this.dynamicReportUrl();
    //   window.open(toUrl, '_blank');
    // }
    // },
    reloadMe() {
      Object.assign(this.$data, initdata());
      this.reloadKey += 1;
    },
  },
  watch: {
    makeBackupToTrue(val) {
      this.isBackupNeeded = val;
    },
  },
};
</script>
